import { AppBar, Box, Dialog, IconButton, Toolbar, Typography, Slide, Button, Grid, DialogTitle } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { ReactComponent as BigArrowIcon } from "../../Assets/svg/bigArrowIcon.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as PhoneIcon } from "../../Assets/svg/PhoneIcon.svg";
import { ReactComponent as GreenArrow } from "../../Assets/svg/greenArrow.svg";
// import { ReactComponent as BooksIcon } from "../../Assets/svg/BooksIcon.svg";
import ButtonNavigation from '../../Components/ButtonNavigation';
import { ReactComponent as ThreeDotsIcon } from "../../Assets/svg/ThreeDotsIcon.svg";
// import { ReactComponent as WhiteLocationIcon } from "../../Assets/svg/WhiteLocationIcon.svg";
import { ReactComponent as PersonCircleIcon } from "../../Assets/svg/PersonCircleIcon.svg";
import { ReactComponent as GrayLocation } from "../../Assets/svg/GrayLocation.svg";
// import { ReactComponent as GreenCheckIcon } from "../../Assets/svg/GreenCheckIcon.svg";
// import { ReactComponent as FloorIcon } from "../../Assets/svg/FloorIcon.svg";
import { ReactComponent as MobileIcon } from "../../Assets/svg/MobileIcon.svg";
import { ReactComponent as MailIcon } from "../../Assets/svg/MailIcon.svg";
// import { ReactComponent as FloorNumIcon } from "../../Assets/svg/FloorNumIcon.svg";
// import { ReactComponent as RoomIcon } from "../../Assets/svg/RoomIcon.svg";
// import { ReactComponent as ZirbanaIcon } from "../../Assets/svg/ZirbanaIcon.svg";
// import { ReactComponent as UsageTypeIcon } from "../../Assets/svg/UsageTypeIcon.svg";
import { ReactComponent as GreenPlus } from "../../Assets/svg/GreenPlus.svg";
import { ReactComponent as LabelsIcon } from "../../Assets/svg/LabelsIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as HouseIcon } from "../../Assets/svg/HouseIcon.svg";
import { ReactComponent as ShareIcon } from "../../Assets/svg/ShareIcon.svg";
import { ReactComponent as SendIcon } from "../../Assets/svg/SendIcon.svg";
import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
import { ReactComponent as PenIcon } from "../../Assets/svg/PenIcon.svg";
import { ReactComponent as BackUpIcon } from "../../Assets/svg/BackUpIcon.svg";
import { ReactComponent as DelIcon } from "../../Assets/svg/DelIcon.svg";
import { ReactComponent as RoundArrowsIcon } from "../../Assets/svg/RoundArrowsIcon.svg";
import { ReactComponent as SettingIcon } from "../../Assets/svg/SettingIcon.svg";
import { ReactComponent as GreenDotIcon } from "../../Assets/svg/GreenDotIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as HomeIcon } from "../../Assets/svg/HomeIcon.svg";
import { ReactComponent as InfrainstractureIcon } from "../../Assets/svg/InfrainstractureIcon.svg";
import { ReactComponent as RoomsIcon } from "../../Assets/svg/RoomsIcon.svg";
// import { Swiper, SwiperSlide } from 'swiper/react';
import { useParams } from "react-router-dom";
// Import Swiper styles
import 'swiper/css';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
import moment from "moment-jalaali"
import { useUserStore } from '../../store/user';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
import { useSnackbar } from 'notistack';
import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import DemandContactModal from "../../Components/DemandContactModal";
import { CheckPermissions } from "../../Components/CheckPermissions";
import Cookies from 'js-cookie'
import { getToken, getUserToken } from "../../Components/PublicFunctions";
import ShareModalCompo from "../../Components/ShareModal";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function LocationMarker(props) {

    return props.position === null ? "" : (
        <Marker position={props.position}>
            <Popup> </Popup>
        </Marker>
    )
}

function DemandDetails(props) {
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }

    const { enqueueSnackbar } = useSnackbar();

    const accessToken = useUserStore((state) => state.accessToken)
    const userInfo = useUserStore((state) => state.userInfo)
    const propFacilities = useUserStore((state) => state.propFacilities)
    const locationId = useUserStore((state) => state.locationId)
    const [ContactModal, setContactModal] = useState(false);
    const [openMoreOptionsModal, setOpenMoreOptionsModal] = useState(false)
    const [openLabelsModal, setOpenLabelsModal] = useState(false)
    const [deletePropModal, setDeletePropModal] = useState(false);
    const [deleteLading, setDeleteLading] = useState(false);


    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [propInfo, setPropInfo] = useState({})
    const [openMapModal, setOpenMapModal] = useState(false)
    const [openBuyFileModal, setOpenBuyFileModal] = useState(false)
    const [buyLoading, setBuyLoading] = useState(false)


    const dataFetchedRef = useRef(false);

    let { search } = useLocation();
    const showMore = useMemo(() => new URLSearchParams(search), [search]).get("showMore");

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        if(showMore)
            handleMoreOptionsModalClick()


    }, [])

   


    useEffect(() => {
            
        if (Object.keys(propInfo).length) {
            if (localStorage.getItem("searchHistory")) {
                var tmp = JSON.parse(localStorage.getItem('searchHistory'))
                if (!tmp[propInfo.Id]) {
                    tmp[propInfo.Id] = {
                        "title": ` ${propInfo.RequestSale == 1 ? "خرید " : ""}
                        ${propInfo.RequestRent == 1 ? "اجاره " : ""}
                        ${propInfo.PropertyTypes && propInfo.PropertyTypes[0] ? ` | ${propInfo.PropertyTypes[0]}` : ""}
                        ${propInfo.PropertyTypes && propInfo.PropertyTypes[1] ? ` | ${propInfo.PropertyTypes[1]}` : ""}
                        ${propInfo.PropertyTypes && propInfo.PropertyTypes[2] ? ` | ${propInfo.PropertyTypes[2]}` : ""}`,
                        "type": "applicant"
                    }
                }
            } else {
                var tmp = {}
                tmp[propInfo.Id] = {
                    "title": ` ${propInfo.RequestSale == 1 ? "خرید " : ""}${propInfo.RequestRent == 1 ? "اجاره " : ""}${propInfo.PropertyTypes && propInfo.PropertyTypes[0] ? ` | ${propInfo.PropertyTypes[0]}` : ""}${propInfo.PropertyTypes && propInfo.PropertyTypes[1] ? ` | ${propInfo.PropertyTypes[1]}` : ""}${propInfo.PropertyTypes && propInfo.PropertyTypes[2] ? ` | ${propInfo.PropertyTypes[2]}` : ""}`,
                    "type": "applicant"
                }
            }
            localStorage.setItem("searchHistory", JSON.stringify(tmp))

             
        }
    }, [propInfo])

    const handleClickOpenDeletePropModal = (id) => {
        setDeletePropModal(true);
    };
    const handleDeletePropModalClose = () => {
        setDeletePropModal(false);
    };

    const handleDelete = async () => {
        setDeleteLading(true)
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: `/applicants/${propInfo.Id}/delete`,
                method: "POST",
                // data: {
                //     "LocationId": locationId
                // },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {

                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("تقاضا شما با موفقیت حذف شد.", { variant });
                    navigate("/applicant")
                    handleMoreOptionsModalClose()

                }

                handleDeletePropModalClose()
                setDeleteLading(false)


            });
        } catch (e) {
            console.error(e);

            handleCloseBackdrop()
        }
    }
    const handleOpenMapModalClick = () => {
        setOpenMapModal(true);
    };
    const handleOpenMapModalClose = () => {
        setOpenMapModal(false);
    };

    const handleOpenBuyFileModalClick = () => {
        setOpenBuyFileModal(true);
    };
    const handleOpenBuyFileModalClose = () => {
        setOpenBuyFileModal(false);
    };

    const handleOpenContactModal = () => {
        setContactModal(true);
    };
    const handleContactModalClose = () => {
        setContactModal(false);
    };

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const [showShareModal, setShowShareModal] = useState(false)
    const handleShareModalOpen = (id) => {
        setShowShareModal(true);
    };
    const handleShareModalClose = () => {
        setShowShareModal(false);
    };

    const { id } = useParams();
    useEffect(() => {

        console.log("id", id)
        console.log("userInfo", userInfo)
        console.log("propInfo", propInfo)

        handleToggleBackdrop()
        if (locationId && locationId != "") {
            try {
                http({
                    // url of the api endpoint (can be changed)
                    url: "/applicants/get/list/by/filter",
                    method: "POST",
                    data: {
                        // "LocationId": locationId,
                        // "AgencyId": [userInfo.Id],
                        // "LocationId": locationId,    
                        "Id": id,
                        "AgencyInfo": true,
                        "LandLordInfo": true

                    },
                    headers: {

                        "Authorization": `Bearer ${accessToken}`

                    }
                }).then((res) => {
                    console.log("propres", res.data.result.Applicants);
                    setPropInfo(res.data.result.Applicants[0])
                    handleCloseBackdrop()
                });

            } catch (e) {
                console.error(e);
                handleCloseBackdrop()
            }
        } else {
            setPropInfo({})
        }

    }, [userInfo])

    const handleBuyFile = () => {
        console.log("credit", userInfo.Credit)
        console.log("FilePrice", propInfo.FilePrice)
        setBuyLoading(true)
        if (userInfo.Credit >= propInfo.FilePrice) {
            try {
                http({
                    url: "/wallet/file/buy",
                    method: "POST",
                    data: {
                        "Properties": [propInfo.Id],
                        "LocationId": locationId
                    },
                    headers: {
                        "Authorization": `Bearer ${accessToken}`
                    }
                }).then((res) => {
                    // console.log("checkout_url", res.result.checkout_url)

                    if (res.data.result == false) {
                        const variant = 'error'
                        enqueueSnackbar(res.data.message, { variant });
                    } else {
                        window.open(res.data.result.checkout_url, '_blank', 'noreferrer');
                    }
                    handleOpenBuyFileModalClose()
                    setBuyLoading(false)
                });

            } catch (e) {
                console.error(e);
                if (e.result.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
                handleOpenBuyFileModalClose()

                setBuyLoading(false)
            }
        } else {
            const variant = 'error'
            enqueueSnackbar("کیف پول خود را شارژ کنید.", { variant });
            handleOpenBuyFileModalClose()
            setBuyLoading(false)
        }

    }

    const handleMoreOptionsModalClick = () => {
        setOpenMoreOptionsModal(true);
    };
    const handleMoreOptionsModalClose = () => {
        setOpenMoreOptionsModal(false);
    };

    const handleLabelsModalClick = () => {
        setOpenLabelsModal(true);
    };
    const handleLabelsModalClose = () => {
        setOpenLabelsModal(false);
    };

    return (
        <Box>
            {propInfo ? <Box>
                <Backdrop
                    sx={{ color: '#fff', zIndex: 99999 }}
                    open={openBackdrop}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Box>
                    <Box className="gray-box rounded-20-bottom" sx={{ px: '20px', py: '10px', display: "flex", justifyContent: "space-between", alignItems: 'center', position: 'relative' }}>
                        <IconButton onClick={goBack}>
                            <BigArrowIcon />
                        </IconButton>
                        {/* <Box sx={{ display: 'flex', gap: '0px' }}>
                            <IconButton sx={{ width: '32px', height: '32px' }}>
                                <GreenArrow className="rotate-180-minus" />
                            </IconButton>
                            <IconButton sx={{ width: '32px', height: '32px' }} >
                                <GreenArrow />
                            </IconButton>
                        </Box> */}

                        <Box>
                            {propInfo.Agency ? <IconButton sx={{ bgcolor: '#D6ECD2!important' }} onClick={handleOpenContactModal}>
                                <PhoneIcon />
                            </IconButton> : null}
                        </Box>
                    </Box>
                    {propInfo && Object.keys(propInfo).length > 0 > 0 ? <Box id="dashboard-content" sx={{ p: 1 }}>
                        <Box sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                            <IconButton onClick={handleMoreOptionsModalClick}>
                                <ThreeDotsIcon />
                            </IconButton>

                            <Box>
                                {propInfo.RequestSale ? `خرید` : ''}
                                {propInfo.RequestRent ? `اجاره` : ''}
                                {propInfo.RequestPreSale ? `پیش خرید` : ''}
                                {propInfo.RequestExchange ? `معاوضه` : ''}
                                {propInfo.RequestAssociate ? `مشارکت` : ''} {propInfo.PropertyTypes && propInfo.PropertyTypes[0]}</Box>

                            <Box>{moment.unix(propInfo.RegisterDate).format("jYYYY/jMM/jDD")}</Box>
                        </Box>
                        {/*<Box sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                           <IconButton className="rounded-50" sx={{ fontSize: "11px", bgcolor: '#29A19C!important', color: '#fff', display: 'flex', gap: '5px' }} onClick={handleOpenMapModalClick}>
                                <WhiteLocationIcon />
                                مشاهده روی نقشه
                            </IconButton> 
                            
                        </Box>*/}


                        <Box className="gray-box" sx={{ borderRadius: '10px', p: 2, mt: 2 }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
                                <Stack
                                    direction="row"
                                    divider={<Divider orientation="vertical" flexItem />}
                                    spacing={1}
                                    sx={{ fontSize: '11px' }}
                                >


                                    {
                                        propInfo.PropertyTypes && propInfo.PropertyTypes.map((item, index) => {
                                            return <Box key={index}>{item}</Box>
                                        })

                                    }

                                </Stack>
                                <Box>
                                    <Typography component="span" sx={{ fontSize: '11px' }}>کد تقاضا : </Typography>
                                    <Typography component="span" sx={{ fontSize: '11px' }}>{propInfo.Row}</Typography>
                                </Box>
                            </Box>
                            {propInfo.RequestSale == 1 ? <Box sx={{ fontSize: '11px', mt: 2 }}>قیمت از {propInfo.MinSalePrice.toLocaleString()} تا {propInfo.MaxSalePrice.toLocaleString()}</Box> : null}
                            {propInfo.RequestRent == 1 ? <Box sx={{ fontSize: '11px', mt: 2 }}>قیمت اجاره از {propInfo.MinRentPrice.toLocaleString()} تا {propInfo.MaxRentPrice.toLocaleString()}</Box> : null}
                            {propInfo.RequestRent == 1 ? <Box sx={{ fontSize: '11px', mt: 1 }}>قیمت رهن از {propInfo.MinMortgagePrice.toLocaleString()} تا {propInfo.MaxMortgagePrice.toLocaleString()}</Box> : null}
                            <Box sx={{ display: 'flex', gap: '5px', fontSize: '11px', mt: 2 }}>
                                <GrayLocation />
                                <Box>
                                    {propInfo.Areas && propInfo.Areas.length ? propInfo.Areas.toString() : "-"}
                                </Box>
                            </Box>
                            <Grid container sx={{ textAlign: 'center', fontSize: '12px', mt: 2 }}>
                                <Grid item xs={4}>
                                    <InfrainstractureIcon />
                                    <Box>زیربنا از {propInfo.MinInfrastructure && propInfo.MinInfrastructure} تا {propInfo.MaxInfrastructure && propInfo.MaxInfrastructure} متر</Box>
                                </Grid>
                                <Grid item xs={4}>
                                    <RoomsIcon />
                                    <Box>{propInfo.MinRoomsCount} خواب</Box>
                                </Grid>
                                <Grid item xs={4}>
                                    <HomeIcon />
                                    <Box>{propInfo.UsageTypes && propInfo.UsageTypes[0]}</Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                            <Box sx={{ display: "flex", alignItems: 'center', gap: '5px' }}>
                                <PersonCircleIcon />
                                <Typography component='span' sx={{ fontSize: '11px' }}>ثبت کننده :</Typography>
                                <Typography component='span' sx={{ fontSize: '11px' }}>{propInfo.RegistrarUserName}</Typography>
                            </Box>
                            <Box>
                                <Typography component='span' sx={{ fontSize: '11px' }}>آخرین ویریش </Typography>
                                <Typography component='span' sx={{ fontSize: '11px' }}>{moment.unix(propInfo.RegisterDate).format("jYYYY/jMM/jDD")}</Typography>
                            </Box>
                        </Box>


                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                خصوصیات
                            </Box>
                            <Box sx={{ p: 2 }}>
                                <Grid container spacing={1}>
                                    {propInfo.PropertyAge && propInfo.PropertyAge.length ?
                                        <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                            <GreenDotIcon />
                                            <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.PropertyAge[0]}</Typography>
                                        </Grid> : ''}
                                    {
                                        propInfo.Floor && propInfo.Floor ?
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <GreenDotIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>کفپوش : </Typography>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Floor}</Typography>
                                            </Grid> : ""
                                    }

                                    {propInfo.KitchenService && propInfo.KitchenService ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>سرویس آشپزخانه : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.KitchenService}</Typography>
                                    </Grid> : ''}
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>حاشیه : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.BrinkValue}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}> وضعیت بنا : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Estatestatus ? propInfo.Estatestatus : "-"}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}> مساحت : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.MaxSpace ? propInfo.MaxSpace : "-"} تا {propInfo.MinSpace ? propInfo.MinSpace : "-"} متر</Typography>
                                    </Grid>
                                    {propInfo.Direction && propInfo.Direction ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>جهت ساختمان : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Direction && propInfo.Direction}</Typography>
                                    </Grid> : ''}
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>نوع سند : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.CertificateType ? propInfo.CertificateType : '-'}</Typography>
                                    </Grid>

                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>متراژ کوچه : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.PassageWidth ? propInfo.PassageWidth : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>تراکم : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Aggregation != "" ? propInfo.Aggregation : '-'}</Typography>
                                    </Grid><Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>تعداد افراد : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Population ? propInfo.Population == 0 ? "مهم نیست" : propInfo.Population : '-'}</Typography>
                                    </Grid>
                                    {/* <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>نما : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Frontage ? propInfo.Frontage : '-'}</Typography>
                                    </Grid> */}
                                    {/* <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>تعداد واحد در هر طبقه : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.UnitsCount ? propInfo.UnitsCount : '-'}</Typography>
                                    </Grid> */}
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>تعداد دانگ : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Dongs ? propInfo.Dongs : '-'}</Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                امتیازات
                            </Box>
                            <Box sx={{ p: 2 }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>آب : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Water != "" ? propInfo.Water : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>برق : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Electricity != "" ? propInfo.Electricity : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>گاز : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Gas != "" ? propInfo.Gas : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>تلفن : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Phone != "" ? propInfo.Phone : '-'}</Typography>
                                    </Grid>

                                </Grid>
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">

                                امکانات
                            </Box>
                            <Box sx={{ p: 2 }}>

                                <Grid container spacing={1}>
                                    {
                                        propInfo.Parking == 1 ?
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <GreenDotIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>پارکینگ</Typography>
                                            </Grid> : null
                                    }
                                    {
                                        propInfo.Elevator == 1 ?
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <GreenDotIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>آسانسور</Typography>
                                            </Grid> : ""
                                    }
                                    {
                                        propInfo.Court == 1 ?
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <GreenDotIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>حیاط</Typography>
                                            </Grid> : ""
                                    }
                                    {
                                        propInfo.Store == 1 ?
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <GreenDotIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>انباری</Typography>
                                            </Grid> : ""
                                    }

                                </Grid>
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                دیگر امکانات
                            </Box>
                            <Box sx={{ p: 2 }}>
                                {propInfo.Facilities && propInfo.Facilities.length > 0 ?
                                    <Grid container spacing={1}>
                                        {
                                            propInfo.Facilities.map((item, index) => {
                                                if (item in propFacilities) {
                                                    return <Grid item xs={6} key={index} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                        <GreenDotIcon />
                                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propFacilities[item]}</Typography>
                                                    </Grid>
                                                }



                                            })
                                        }
                                    </Grid> :
                                    <Box sx={{ textAlign: 'center' }}>موردی ثبت نشده!</Box>}
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                برچسب ها
                            </Box>
                            <Box sx={{ p: 2 }}>
                                <Grid container spacing={1}>

                                </Grid>
                            </Box>
                        </Box>
                        {/* <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                طبقات
                            </Box>
                            <Box sx={{ p: 2 }}>
                                {console.log("propInfo.Floors", propInfo.Floors)}
                                {propInfo.Floors && propInfo.Floors.length > 0 ?
                                    propInfo.Floors.map((item, index) => {
                                        return [<Box key={index}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <FloorIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>طبقه {item.FloorNo}</Typography>
                                            </Box>
                                            <Grid container spacing={1} key={index} sx={{ mr: "5px", mt: 1 }}>
                                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>زیربنا : {item.Infrastructure}</Typography>
                                                </Grid>
                                                {item.Water && item.Water != "" ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>آب</Typography>
                                                </Grid> : null}
                                                {item.Electricity && item.Electricity != "" ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>برق</Typography>
                                                </Grid> : null}
                                                {item.Gas && item.Gas != "" ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>گاز</Typography>
                                                </Grid> : null}
                                                {item.Phone && item.Phone != "" ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>تلفن</Typography>
                                                </Grid> : null}
                                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>تعداد اتاق : </Typography>
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>{item.RoomsCount != "" ? item.RoomsCount : '-'}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>]
                                    })

                                    : <Box sx={{ textAlign: 'center' }}>طبقه ای ثبت نشده!</Box>
                                }
                            </Box>
                        </Box> */}
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                توضیحات عمومی
                            </Box>
                            <Box sx={{ p: 2 }}>
                                {propInfo.PublicDescription}
                            </Box>
                        </Box>
                        {userInfo.Id == propInfo.RegistrarAgency && <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                توضیحات خصوصی
                            </Box>
                            <Box sx={{ p: 2 }}>
                                {propInfo.Description}
                            </Box>
                        </Box>}
                        {userInfo.Id == propInfo.RegistrarAgency && <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                مشخصات متقاضی
                            </Box>
                            <Box sx={{ p: 2 }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>کد تقاضا :</Typography>
                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Row}</Typography>
                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>نام متقاضی :</Typography>
                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.FullName}</Typography>
                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>شغل : </Typography>
                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>املاک</Typography>
                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>

                                                <Typography component='span' sx={{ fontSize: '12px' }}>تاریخ بازیابی : </Typography>

                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>

                                                <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.PeriodInDays > 0 ? moment.unix(propInfo.PeriodInDays).format("jYYYY/jMM/jDD") : "نا محدود"}</Typography>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px', flexDirection: 'column' }}>
                                        {propInfo.Mobile && <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                                            <a href={`tel:${propInfo.Mobile && propInfo.Mobile}`}>
                                                <MobileIcon />
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flex: "1" }}>
                                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px', textAlign: "center" }}>{propInfo.Mobile && propInfo.Mobile}</Box>
                                                    <GreenArrow />
                                                </Box>
                                            </a>
                                        </Button>}
                                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                                            <a href={`sms:${propInfo.Mobile && propInfo.Mobile}`}>
                                                <MailIcon />
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flex: "1" }}>
                                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px', textAlign: "center" }}>{propInfo.Mobile && propInfo.Mobile}</Box>
                                                    <GreenArrow />
                                                </Box>
                                            </a>
                                        </Button>
                                        {propInfo.Tell && <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                                            <a href={`tel:${propInfo.Tell && propInfo.Tell}`}>
                                                <PhoneIcon />
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flex: "1" }}>
                                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px', textAlign: "center" }}>{propInfo.Tell && propInfo.Tell}</Box>
                                                    <GreenArrow />
                                                </Box>
                                            </a>
                                        </Button>}
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>}


                    </Box> : !openBackdrop ? <Box id="dashboard-content" sx={{ p: 1, textAlign: 'center', p: 1 }}>موردی یافت نشد!</Box> : <Box id="dashboard-content" sx={{ p: 1, textAlign: 'center', p: 1 }}></Box>}
                </Box>
                <ButtonNavigation />


                {openMapModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openMapModal}
                    onClose={handleOpenMapModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {/* انتخاب کنید */}
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleOpenMapModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', height: '100%' }}>
                        <MapContainer center={[propInfo.Latitude && propInfo.Latitude != "" ? propInfo.Latitude : 36.32386694335946, propInfo.Longitude && propInfo.Longitude != "" ? propInfo.Longitude : 59.579383705135136]} zoom={13} scrollWheelZoom={false} className="h-100">
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <LocationMarker position={[propInfo.Latitude, propInfo.Longitude]} />

                        </MapContainer>

                    </Box>
                </Dialog>}
                {openBuyFileModal && <Dialog className="dialog-box"
                    open={openBuyFileModal}
                    onClose={handleOpenBuyFileModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            آیا میخواهید فایل این تقاضا را خریداری کنید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleOpenBuyFileModalClose}>خیر</Button>
                        <Button onClick={handleBuyFile} autoFocus>
                            {!buyLoading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                        </Button>
                    </DialogActions>
                </Dialog>}


                {ContactModal && <DemandContactModal ContactModal={ContactModal} handleContactModalClose={handleContactModalClose} propInfo={propInfo} />}

                {openMoreOptionsModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openMoreOptionsModal}
                    onClose={handleMoreOptionsModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {/* انتخاب کنید */}
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleMoreOptionsModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>

                        <Button className="green-outline-btn" onClick={handleLabelsModalClick} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px', border: '0px !important', bgcolor: '#D6ECD2!important' }}>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <LabelsIcon />
                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>وظایف و نشانه گذاری ها</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <HouseIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارتباطات</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        {propInfo?.RegistrarUser == getUserToken()?.UserId || getUserToken()?.IsMaster == 1 ? <Button className="green-outline-btn" onClick={handleShareModalOpen} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                        
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <ShareIcon />
                                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>اشتراک گذاری</Box>
                                            </Box>
                                            <ArrowRightIcon className="rotate-180-minus" />
                        
                                        </Button> : ""}
                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <SendIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارسال</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <CalendarIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>یادآوری</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        {CheckPermissions(userInfo, "applicant_edit") ? <Button className="green-outline-btn" onClick={() => navigate(`/demand_edit/${propInfo.Id}`)} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <PenIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ویرایش</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button> : ""}
                        {CheckPermissions(userInfo, "applicant_archive") ? <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <BackUpIcon />
                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>بایگانی</Box>

                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />
                        </Button> : ""}
                        {CheckPermissions(userInfo, "applicant_delete") ? <Button onClick={handleClickOpenDeletePropModal} className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <DelIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>حذف</Box>
                            </Box>
                            {/* <ArrowRightIcon className="rotate-180-minus" /> */}

                        </Button> : ""}
                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <MailIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارسال پیام</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        <Button className="green-outline-btn" onClick={() => navigate(`/applicant/adapt/${propInfo.Id}/${propInfo.Row}`)} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <RoundArrowsIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>انطباق سازی</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                    </Box>
                </Dialog>}

                {deletePropModal && <Dialog className="dialog-box"
                    open={deletePropModal}
                    onClose={handleDeletePropModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            آیا میخواهید این تقاضا را حذف کنید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDeletePropModalClose}>خیر</Button>
                        <Button onClick={handleDelete} autoFocus>
                            {!deleteLading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                        </Button>
                    </DialogActions>
                </Dialog>}

                {openLabelsModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openLabelsModal}
                    onClose={handleLabelsModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>
                            <IconButton>
                                <SettingIcon />
                            </IconButton>
                            <Typography sx={{ mx: 'auto', fontSize: '12px' }} variant="h6" component="div">
                                نشانه گذاری ها
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleLabelsModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>

                        </Toolbar>
                    </AppBar>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>

                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px', border: '0px !important', bgcolor: '#D6ECD2!important' }}>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <LabelsIcon />
                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>وظایف و نشانه گذاری ها</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <HouseIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارتباطات</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        {/* <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <ShareIcon />
                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>اشتراک گذاری</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button> */}
                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <SendIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارسال</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <CalendarIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>یادآوری</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        {CheckPermissions(userInfo, "applicant_edit") ? <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <PenIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ویرایش</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button> : ""}
                        {CheckPermissions(userInfo, "applicant_archive") ? <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <BackUpIcon />
                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>بایگانی</Box>

                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />
                        </Button> : ""}
                        {CheckPermissions(userInfo, "applicant_delete") ? <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <DelIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>حذف</Box>
                            </Box>
                            {/* <ArrowRightIcon className="rotate-180-minus" /> */}

                        </Button> : ""}
                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <MailIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارسال پیام</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        <Button className="green-outline-btn" onClick={() => navigate(`/applicant/adapt/${propInfo.Id}/${propInfo.Row}`)} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <RoundArrowsIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>انطباق سازی</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                    </Box>
                </Dialog>}

                {showShareModal && <ShareModalCompo handleShareModalClose={handleShareModalClose} showShareModal={showShareModal} propId={propInfo?.Id} />}

            </Box> : !openBackdrop ? <Box id="dashboard-content" sx={{ p: 5, textAlign: 'center' }}>موردی یافت نشد!</Box> : ""}

        </Box>
    );
}

export default DemandDetails;